export default __webpack_public_path__ + "static/media/member_upload_template.36172991.csv";